import { SagaNodeKind, type SagaNodeKind as SagaNodeKindType } from '@/dtos/SagaWorkflow'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCircleCheck, faCircleXmark, faClock, faPlay } from '@fortawesome/pro-light-svg-icons'

// One glyph per kind flag, in render/legend order. Normal (no flag) carries no glyph; combined kinds (e.g.
// Start | Wait) render every matching glyph.
export const sagaNodeKindFlags: { flag: SagaNodeKindType; icon: IconDefinition; label: string }[] = [
  { flag: SagaNodeKind.Start, icon: faPlay, label: 'Začátek' },
  { flag: SagaNodeKind.Wait, icon: faClock, label: 'Čekání' },
  { flag: SagaNodeKind.TerminalOk, icon: faCircleCheck, label: 'Dokončeno' },
  { flag: SagaNodeKind.TerminalFail, icon: faCircleXmark, label: 'Ukončeno chybou' },
]

// Glyphs for a (possibly combined) kind — Start | Wait → [play, clock]; Normal → [].
export const sagaNodeKindIcons = (kind: SagaNodeKindType): IconDefinition[] =>
  sagaNodeKindFlags.filter(f => (kind & f.flag) !== 0).map(f => f.icon)
